import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
export var useModal = function useModal() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShown = _useState2[0],
    setIsShown = _useState2[1];
  var toggle = function toggle() {
    return setIsShown(!isShown);
  };
  return {
    isShown: isShown,
    toggle: toggle
  };
};